<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-loader-component></app-loader-component>